import cyjh from '@/assets/activity/cyjh.png';
import zbf from '@/assets/activity/zbf.png';
import time from '@/assets/activity/time.png';
import addr from '@/assets/activity/addr.png';
import loca from '@/assets/activity/loca.png';
export default {
  name: 'ActPage1',

  setup() {
    document.getElementById('viewport').content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0;';
    return {
      cyjh,
      zbf,
      time,
      addr,
      loca
    };
  }

};